import gradientPallet from './gradientPallet';
import designs from './gateDesigns.json';

const getGateDesignByName = (name) => {
  const { gradientName, icon, shape } = designs[name] || designs.default;

  const grd = gradientPallet[gradientName];
  return { grd, icon, shape };
};

export default getGateDesignByName;
